const headerEl = document.getElementById("site-header");
const logoEl = document.getElementById("site-logo");

function applyScrolledState(scrolled) {
  if (scrolled) {
    // Header visine (manje kad scrolla)
    headerEl.classList.remove("h-[95px]", "md:h-[100px]", "lg:h-[165px]");
    headerEl.classList.add(
      "h-[85px]",
      "md:h-[80px]",
      "lg:h-[120px]",
      "shadow-lg",
    );

    // Logo visine (malo manje kad scrolla)
    logoEl.classList.remove("h-[65px]", "lg:h-[55px]", "xl:h-[65px]");
    logoEl.classList.add("h-[40px]", "lg:h-[40px]", "xl:h-[40px]");
  } else {
    // Vrati početne visine
    headerEl.classList.add("h-[95px]", "md:h-[100px]", "lg:h-[165px]");
    headerEl.classList.remove(
      "h-[85px]",
      "md:h-[80px]",
      "lg:h-[120px]",
      "shadow-lg",
    );

    logoEl.classList.add("h-[45px]", "lg:h-[45px]", "xl:h-[45px]");
    logoEl.classList.remove("h-[40px]", "lg:h-[40px]", "xl:h-[40px]");
  }
}

// Inicijalno stanje (ako je već skrolano npr. na reload)
applyScrolledState(window.scrollY > 0);

// Slušaj scroll
window.addEventListener("scroll", () => {
  applyScrolledState(window.scrollY > 0);
});

// Tvoj postojeći mobile toggle ostaje isti:
document
  .getElementById("mobile-menu-toggle")
  .addEventListener("click", function () {
    document.getElementById("mobile-menu").classList.toggle("hidden");
  });
$(document).ready(function () {
  $(".slick-slider").slick({
    dots: true,
    arrows: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
  });
});
$(document).ready(function () {
  $(".slider-1").slick({
    autoplay: true,
    autoplaySpeed: 8000,
    arrows: false,
    dots: false,
    infinite: true,
    speed: 500,
    fade: true,
    cssEase: "linear",
  });
  $(".slider-2").slick({
    autoplay: true,
    autoplaySpeed: 8000,
    arrows: false,
    dots: false,
    infinite: true,
    speed: 500,
    fade: true,
    cssEase: "linear",
  });
  $(".testimonial-slider").slick({
    dots: true,
    arrows: false,
    infinite: true,
    speed: 500,
    fade: true,
    cssEase: "linear",
    slidesToShow: 1,
    adaptiveHeight: true,
    autoplay: true,
    autoplaySpeed: 5000,
  });
  $(".impact_report_lab").slick({
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: false,
  });
});

function togglePopup() {
  document.getElementById("popup").classList.toggle("hidden");
}

function closePopup(event) {
  if (event.target.id === "popup") {
    togglePopup();
  }
}

$(document).ready(function () {
  $("#loadMore").click(function () {
    $(".gallery-item:hidden").slice(0, 9).slideDown().removeAttr("hidden");
    if ($(".gallery-item:hidden").length === 0) {
      $("#loadMore").fadeOut();
    }
  });
});
